export const formatDateTime = (dateString) => {
  if (!dateString) return "-";
  const formatted = new Date(dateString).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  return formatted.replace(", ", " ");
};